import { render, staticRenderFns } from "./ListarVentasEntregadas.vue?vue&type=template&id=5d9a2d73&"
import script from "./ListarVentasEntregadas.vue?vue&type=script&lang=js&"
export * from "./ListarVentasEntregadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports